var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFarwardicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "26px",
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Service-Data-Accesses",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "08.-Navigation/01.-Product-Navigation/02.-Product-Navigation---DevOps-Copy",
    transform: "translate(-19.000000, -624.000000)",
    stroke: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(20.000000, 614.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(0.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Path-2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(8.940022, 12.000000) rotate(-270.000000) translate(-8.940022, -12.000000) ",
    points: "3.9400223 9.47330574 8.91049027 14.5266943 13.9400223 9.47330574"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6.41332804,
    y1: 12,
    x2: 18.413328,
    y2: 12,
    id: "Path-3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,24 C18.627417,24 24,18.627417 24,12 C24,5.372583 18.627417,0 12,0 C5.372583,0 0,5.372583 0,12 C0,18.627417 5.372583,24 12,24 Z",
    id: "Oval",
    transform: "translate(12.000000, 12.000000) scale(-1, 1) translate(-12.000000, -12.000000) "
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFarwardicon);
export default __webpack_public_path__ + "static/media/farwardicon.e1480efa4480b026615d78744227b599.svg";
export { ForwardRef as ReactComponent };